export default __webpack_public_path__ + "static/media/wanna3.741fc2b8.webp";